const FooterSection = () => (
  <footer className="bg-[#060e08] text-white">
    {/* CTA Banner */}
    <div id="contact" className="bg-[#0f1a14] border-y border-[#c9a84c]/20 py-12">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h3 className="text-xl md:text-2xl font-bold text-white mb-2">立即获取免费调查方案</h3>
        <p className="text-white/50 text-sm mb-6">专业团队24小时在线，严格保密，高效服务</p>
        <a
          href="tel:400-000-0000"
          className="inline-flex items-center gap-2 bg-[#c9a84c] hover:bg-[#b8963e] text-[#0f1a14] font-bold px-8 py-3 rounded-md text-base transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-phone-line"></i>
          免费咨询热线
        </a>
      </div>
    </div>

    <div className="max-w-6xl mx-auto px-4 md:px-6 py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
        <div>
          <h3 className="text-base font-bold mb-4 text-[#c9a84c]">猎鹰定位找人</h3>
          <p className="text-xs text-white/40 leading-relaxed">专业调查 · 全程保密 · 高效服务。猎鹰侦探事务所提供全国范围内的专业调查服务。</p>
        </div>
        <div>
          <h3 className="text-sm font-bold mb-4 text-white/80">关于我们</h3>
          <ul className="space-y-2">
            {['公司简介', '服务承诺', '法律声明', '联系我们'].map(item => (
              <li key={item}>
                <a href="#" className="text-xs text-white/40 hover:text-[#c9a84c] transition-colors cursor-pointer">{item}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-bold mb-4 text-white/80">服务项目</h3>
          <ul className="space-y-2">
            {['婚姻调查', '定位找人', '商业调查', '资产调查'].map(item => (
              <li key={item}>
                <a href="#services" className="text-xs text-white/40 hover:text-[#c9a84c] transition-colors cursor-pointer">{item}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-bold mb-4 text-white/80">平台导航</h3>
          <ul className="space-y-2">
            {['常见问题', '调查流程', '成功案例', '网站地图'].map(item => (
              <li key={item}>
                <a href="#" className="text-xs text-white/40 hover:text-[#c9a84c] transition-colors cursor-pointer">{item}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 pt-6 text-center space-y-2">
        <p className="text-xs text-white/30">© 2023-2025 猎鹰调查服务平台 版权所有</p>
        <p className="text-xs text-white/20">本站内容仅供参考，实际服务请通过正规渠道咨询</p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="text-xs text-white/25 hover:text-white/50 flex items-center gap-1 cursor-pointer">
            <img src="https://www.ngcac.com/assets/images/icp.png" alt="ICP备案" width={14} height={14} />
            京ICP备2025032667号-1
          </a>
          <a href="http://www.beian.gov.cn/" target="_blank" rel="noopener noreferrer" className="text-xs text-white/25 hover:text-white/50 flex items-center gap-1 cursor-pointer">
            <img src="https://www.ngcac.com/assets/images/gongan.png" alt="公安备案" width={14} height={14} />
            京公网安备11010802030001号
          </a>
        </div>
        <p className="text-xs text-white/15 max-w-2xl mx-auto leading-relaxed">本网站提供的案例与内容仅供参考，不构成具体承诺，服务质量以实际合同为准。我们严格遵守法律法规，不从事任何非法活动，所有调查服务均在法律许可范围内开展。</p>
      </div>
    </div>
  </footer>
);

export default FooterSection;
